// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1661":"d8f0c824","1952":"c2b09d28","2794":"8d33fa77","3244":"c5d384f0","3533":"0a966783","3758":"0f314096","6272":"3193a5c9","6698":"146ae583"}[chunkId] + ".chunk.css";
};